export default "__VITE_ASSET__BEdamuw$__"